import silliaBackground from './assets/img/lipu-background.png';
import silliaLogo from './assets/img/lipu_logo.png';
import silliaLogoMobile from './assets/img/lipu_logo.png';
import silliaHeroBackground from './assets/img/lipu-background.png';
import silliaModulesBackground from './assets/img/backgroundLipu.png';

// Theme configuration and variables
export const theme = {
  // Colors
  colorPrimary: '#FECE04',
  colorSecondary: '#016837',
  colorTertiary: '#4A9B5E',
  colorAvatar: '#E8F5E8',
  colorIcon: '#016837',
  colorBgContainer: '#FFFFFF',
  colorBgDisabled: '#F1F1F1',
  colorTextDescription: '#00000073',
  colorTextButton: '#000000',
  colorSplit: '#0000000f',
  layoutBg: '#F1F1F1',
  colorText: '#000000',
  colorPrimaryBorderHover: '#FFF5B8',
  colorPrimaryBgHover: '#FFFEF0',
  colorIconInbox: '#21212F45',
  colorBgTag: '#E8F5E8',
  colorTagText: '#016837',
  colorTagBorder: '#016837',
  colorIconWidget: '#016837',
  colorCardHover: '#F8F8F8',
  colorCardShadow: 'rgba(0, 0, 0, 0.1)',
  colorCardShadowHover: 'rgba(0, 0, 0, 0.15)',
  colorTextMuted: '#BFBFBF',
  colorTextSecondary: '#8C8C8C',
  colorTextPrimary: '#262626',
  colorStatusUnknown: '#FECE04',
  colorStatusUnknownBg: '#FFFBEC',
  colorStatusUnknownBorder: '#FEE499',
  colorIconLogin: '#F1F1F1',
  backgroundUrl: `url(${silliaBackground})`,
  logoUrl: `url(${silliaLogo})`,
  logoMobileUrl: `url(${silliaLogoMobile})`,
  heroBackgroundUrl: `url(${silliaHeroBackground})`,
  modulesBackgroundUrl: `url(${silliaModulesBackground})`,
  heroTextColor: '#f7f7f6',
  appName: 'Lipu',
  colorBgElevated: '#FFFFFF',
  colorTitleLogin: '#F1F1F1',
  colorTopBarBg: '#E8F5E8',
  colorTopBarBorder: 'rgba(33, 33, 47, 0.06)',
  colorTopBarText: 'rgba(33, 33, 47, 0.88)',
  colorTopBarBadgeBg: '#D4E8D4',
  colorTopBarBadgeBorder: '#4A9B5E',
  colorTopBarBadgeText: '#016837',
  colorTopBarReturnHover: '#016837',
  colorAssistantBadgeBg: '#D4E8D4',
  colorAssistantBadgeText: '#4A9B5E',
  colorAssistantBadgeBorder: '#4A9B5E',
  colorMetricsBarFill: '#D4E8D4',
  colorMetricsLine: '#4A9B5E',
  colorMetricsEscalations: '#016837',
  colorMetricsMessages: '#D4E8D4',
  colorMetricsCategory1: '#016837',
  colorMetricsCategory2: '#4A9B5E',
  colorMetricsCategory3: '#6BB77B',
  colorMetricsCategory4: '#2D8650',
  colorMetricsCategory5: '#1A5C2E',

  // Border Radius
  borderRadiusXS: 8,
  borderRadiusSM: 12,

  // Padding
  paddingXXL: 48,
  paddingXL: 32,
  paddingLG: 24,
  paddingSM: 16,
  paddingXS: 8,

  // Margin
  marginXL: 32,
  marginLG: 24,
  marginSM: 16,
  marginXS: 8,

  // Font
  fontSize: 14,
  fontSizeIcons: 24,

  //gap
  gapXL: 48,
  gapLG: 32,
  gapSM: 16,
  gapXS: 8,
};

// CSS Variables for custom classes
export const cssVariables = `
  :root {
    --ant-gapXL: ${theme.gapXL}px;
    --ant-gapLG: ${theme.gapLG}px;
    --ant-gapSM: ${theme.gapSM}px;
    --ant-gapXS: ${theme.gapXS}px;
    --ant-paddingXXL: ${theme.paddingXXL}px;
    --ant-paddingXL: ${theme.paddingXL}px;
    --ant-paddingLG: ${theme.paddingLG}px;
    --ant-paddingSM: ${theme.paddingSM}px;
    --ant-paddingXS: ${theme.paddingXS}px;
    --ant-marginXL: ${theme.marginXL}px;
    --ant-marginLG: ${theme.marginLG}px;
    --ant-marginSM: ${theme.marginSM}px;
    --ant-marginXS: ${theme.marginXS}px;
    --ant-borderRadiusXS: ${theme.borderRadiusXS}px;
    --ant-borderRadiusSM: ${theme.borderRadiusSM}px;
    --ant-colorTextDescription: ${theme.colorTextDescription};
    --ant-colorBgContainer: ${theme.colorBgContainer};
    --ant-colorSplit: ${theme.colorSplit};
    --ant-colorIcon: ${theme.colorIcon};
    --ant-colorPrimary: ${theme.colorPrimary};
    --ant-colorSecondary: ${theme.colorSecondary};
    --ant-colorTertiary: ${theme.colorTertiary};
    --ant-colorPrimaryBorderHover: ${theme.colorPrimaryBorderHover};
    --ant-colorPrimaryBgHover: ${theme.colorPrimaryBgHover};
    --ant-colorIconInbox: ${theme.colorIconInbox};
    --ant-colorTextButton: ${theme.colorTextButton};
    --ant-colorAvatar: ${theme.colorAvatar};
    --ant-colorBgDisabled: ${theme.colorBgDisabled};
    --ant-colorText: ${theme.colorText};
    --ant-colorBgTag: ${theme.colorBgTag};
    --ant-colorTagText: ${theme.colorTagText};
    --ant-colorTagBorder: ${theme.colorTagBorder};
    --ant-colorIconWidget: ${theme.colorIconWidget};
    --ant-colorCardHover: ${theme.colorCardHover};
    --ant-colorCardShadow: ${theme.colorCardShadow};
    --ant-colorCardShadowHover: ${theme.colorCardShadowHover};
    --ant-colorTextMuted: ${theme.colorTextMuted};
    --ant-colorTextSecondary: ${theme.colorTextSecondary};
    --ant-colorTextPrimary: ${theme.colorTextPrimary};
    --ant-colorStatusUnknown: ${theme.colorStatusUnknown};
    --ant-colorStatusUnknownBg: ${theme.colorStatusUnknownBg};
    --ant-colorStatusUnknownBorder: ${theme.colorStatusUnknownBorder};
    --ant-fontSizeIcons: ${theme.fontSizeIcons}px;
    --ant-backgroundUrl: ${theme.backgroundUrl};
    --ant-logoUrl: ${theme.logoUrl};
    --ant-logoMobileUrl: ${theme.logoMobileUrl};
    --ant-heroBackgroundUrl: ${theme.heroBackgroundUrl};
    --ant-modulesBackgroundUrl: ${theme.modulesBackgroundUrl};
    --ant-heroTextColor: ${theme.heroTextColor};
    --ant-appName: ${theme.appName};
    --ant-layoutBg: ${theme.layoutBg};
    --ant-colorBgElevated: ${theme.colorBgElevated};
    --ant-colorTitleLogin: ${theme.colorTitleLogin};
    --ant-colorIconLogin: ${theme.colorIconLogin};
    --ant-colorTopBarBg: ${theme.colorTopBarBg};
    --ant-colorTopBarBorder: ${theme.colorTopBarBorder};
    --ant-colorTopBarText: ${theme.colorTopBarText};
    --ant-colorTopBarBadgeBg: ${theme.colorTopBarBadgeBg};
    --ant-colorTopBarBadgeBorder: ${theme.colorTopBarBadgeBorder};
    --ant-colorTopBarBadgeText: ${theme.colorTopBarBadgeText};
    --ant-colorTopBarReturnHover: ${theme.colorTopBarReturnHover};
    --ant-colorAssistantBadgeBg: ${theme.colorAssistantBadgeBg};
    --ant-colorAssistantBadgeText: ${theme.colorAssistantBadgeText};
    --ant-colorAssistantBadgeBorder: ${theme.colorAssistantBadgeBorder};
    --ant-colorMetricsBarFill: ${theme.colorMetricsBarFill};
    --ant-colorMetricsLine: ${theme.colorMetricsLine};
    --ant-colorMetricsEscalations: ${theme.colorMetricsEscalations};
    --ant-colorMetricsMessages: ${theme.colorMetricsMessages};
    --ant-colorMetricsCategory1: ${theme.colorMetricsCategory1};
    --ant-colorMetricsCategory2: ${theme.colorMetricsCategory2};
    --ant-colorMetricsCategory3: ${theme.colorMetricsCategory3};
    --ant-colorMetricsCategory4: ${theme.colorMetricsCategory4};
    --ant-colorMetricsCategory5: ${theme.colorMetricsCategory5};
  }

  .ant-typography,
  .ant-typography h1,
  .ant-typography h2,
  .ant-typography h3,
  .ant-typography h4,
  .ant-typography h5,
  .ant-typography h6,
  .ant-typography p {
    margin: 0 !important;
  }
`;

// Ant Design theme configuration
export const antdTheme = {
  token: {
    colorPrimary: theme.colorPrimary,
    colorBgContainer: theme.colorBgContainer,
    colorBgContainerDisabled: theme.colorBgDisabled,
    colorTextDescription: theme.colorTextDescription,
    colorSplit: theme.colorSplit,
    borderRadiusXS: theme.borderRadiusXS,
    borderRadiusSM: theme.borderRadiusSM,
    paddingXL: theme.paddingXL,
    paddingLG: theme.paddingLG,
    paddingSM: theme.paddingSM,
    paddingXS: theme.paddingXS,
    marginXL: theme.marginXL,
    marginLG: theme.marginLG,
    marginSM: theme.marginSM,
    marginXS: theme.marginXS,
    fontSize: theme.fontSize,
  },
  components: {
    Button: {
      colorPrimary: theme.colorPrimary,
      colorTextLightSolid: theme.colorTextButton,
    },
    Tabs: {
      itemSelectedColor: theme.colorSecondary,
      inkBarColor: theme.colorSecondary,
      colorIcon: theme.colorSecondary,
      itemColor: theme.colorText,
      itemHoverColor: theme.colorTertiary,
    },
    Switch: {
      colorPrimary: theme.colorTertiary,
      colorBgContainerDisabled: theme.colorBgDisabled,
    },
    Input: {
      activeBorderColor: theme.colorSecondary,
      hoverBorderColor: theme.colorSecondary,
      colorBgContainer: theme.colorBgContainer,
      colorText: theme.colorTextDescription,
    },
    Card: {
      paddingLG: theme.paddingLG,
      borderRadiusXS: theme.borderRadiusXS,
      colorBgContainer: theme.colorBgContainer,
    },
    Typography: {
      colorTextDescription: theme.colorTextDescription,
    },
    Layout: {
      colorBgLayout: theme.layoutBg,
    },
    Pagination: {
      colorPrimary: theme.colorTertiary,
    },
    Spin: {
      colorPrimary: theme.colorIcon,
    },
    Radio: {
      colorPrimary: theme.colorSecondary,
      buttonSolidCheckedColor: theme.colorSecondary,
      dotColorDisabled: theme.colorBgDisabled,
    },
    Menu: {
      itemSelectedColor: theme.colorSecondary,
      itemSelectedBg: '#ffffff',
      itemHoverColor: theme.colorTextPrimary,
      itemHoverBg: 'rgba(33, 33, 47, 0.04)',
      subMenuItemBg: 'transparent',
      itemBg: 'transparent',
    },
    Progress: {
      defaultColor: theme.colorSecondary,
    },
  },
};
